import { useEffect } from 'react';

import { getHidePhi, setHidePhi } from '@/services/hidePhiStore';

/**
 * Ctrl+Shift+H on every platform. Cmd+Shift would set off the screenshot blur and Cmd+Shift+H
 * opens the home page in Chrome on macOS, while Ctrl+Shift+H is free in the browsers we support.
 */
export const HIDE_PHI_SHORTCUT_LABEL = 'Ctrl+Shift+H';

const isHidePhiShortcut = (event: KeyboardEvent) =>
  event.ctrlKey &&
  event.shiftKey &&
  !event.metaKey &&
  !event.altKey &&
  event.key.toLowerCase() === 'h';

const useHidePhiHotkey = () => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!isHidePhiShortcut(event)) return;

      event.preventDefault();
      // Holding the shortcut auto-repeats keydown, which would flip the blur back and forth.
      if (!event.repeat) setHidePhi(!getHidePhi());
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);
};

export default useHidePhiHotkey;
